import { render, staticRenderFns } from "./Clerks.vue?vue&type=template&id=49ceefbc&scoped=true"
import script from "./Clerks.vue?vue&type=script&lang=js"
export * from "./Clerks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ceefbc",
  null
  
)

export default component.exports